import { useDispatch, useSelector } from 'react-redux';
import { doGetHistoryTransaction, doGetHistoryTransactionDetail } from '../../../redux/onlineSales/onlineSales.actions';

export default function useHistoryTransactions() {
    const dispatch = useDispatch();

    const { loadingHistory, historyTransactions, historyDetail, historyTransactionDetail } = useSelector((state) => state?.onlineSales);

    const handleGetAllHistoryTransactions = () => {
        dispatch(doGetHistoryTransaction());
    };

    const handleGetHistoryTransactionDetail = (billNo, orderType) => {
        dispatch(doGetHistoryTransactionDetail(billNo, orderType));
    };

    return { loadingHistory, historyTransactions, historyDetail, historyTransactionDetail, handleGetAllHistoryTransactions, handleGetHistoryTransactionDetail };
}
